export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
            联系投稿
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            有好的水果视频在线平台推荐？欢迎联系我们
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="text-center p-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-accent-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">投稿邮箱</h3>
                <p className="text-xs text-foreground-500">submit@sunflowervideo.cn</p>
              </div>
              <div className="text-center p-4">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-wechat-line text-secondary-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">微信公众号</h3>
                <p className="text-xs text-foreground-500">向日葵视频导航</p>
              </div>
              <div className="text-center p-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-timer-line text-primary-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">响应时间</h3>
                <p className="text-xs text-foreground-500">工作日 24h 内回复</p>
              </div>
            </div>

            <div className="border-t border-background-200 pt-6">
              <h3 className="text-sm font-bold text-foreground-900 mb-4 text-center">
                推荐平台或反馈意见
              </h3>
              <form className="space-y-4" data-readdy-form>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                      你的昵称
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="请输入昵称"
                      className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-all"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                      联系邮箱
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="请输入邮箱"
                      className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-all"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                    平台名称
                  </label>
                  <input
                    type="text"
                    name="platform_name"
                    placeholder="请输入推荐的水果视频在线平台名称"
                    className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-all"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                    推荐理由
                  </label>
                  <textarea
                    name="reason"
                    rows={4}
                    maxLength={500}
                    placeholder="请简要描述该平台的特色与推荐理由（500字以内）"
                    className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-all resize-none"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">限500字符</p>
                </div>
                <div className="anti-spam-field">
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>
                <button
                  type="submit"
                  className="w-full py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors cursor-pointer text-sm whitespace-nowrap"
                >
                  <i className="ri-send-plane-line mr-2"></i>提交推荐
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}